import { down, useMediaQuery } from "@/hooks";
import Header from "./header";
import Main from "./main";
import { NavMobileLayout, NavVerticalLayout, useFilteredNavData } from "./nav";

export default function DashboardLayout() {
	const isMobile = useMediaQuery(down("md"));

	return (
		<div
			data-slot="slash-layout-root"
			className="w-full min-h-screen bg-background"
		>
			{isMobile ? <MobileLayout /> : <PcLayout />}
		</div>
	);
}

function MobileLayout() {
	const navData = useFilteredNavData();
	return (
		<>
			{/* Sticky Header */}
			<Header leftSlot={<NavMobileLayout data={navData} />} />
			<Main />
		</>
	);
}

function PcLayout() {
	const navData = useFilteredNavData();
	return (
		<>
			{/* Fixed Header */}
			<NavVerticalLayout data={navData} />

			<div className="relative w-full min-h-screen flex flex-col transition-[padding] duration-300 ease-in-out pl-[var(--layout-nav-width)]">
				<Header />
				<Main />
			</div>
		</>
	);
}
